				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class SatisfactionSurveyQuestionService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('SatisfactionSurveyQuestion');
	}
	
	loadAll(active: boolean) : Observable<TooBig4Car.Logic.SatisfactionSurveyQuestion[]> {
		var loc = this.url + '?active=' + (active ?? true);
		return this.myBaseService.loadAll(loc);
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.SatisfactionSurveyQuestion> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.SatisfactionSurveyQuestion> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.SatisfactionSurveyQuestion>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<TooBig4Car.Logic.SatisfactionSurveyQuestion[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}
				
